import Vue from 'vue';
import items from './items';

const success = (resolve) => {
  items();
  resolve();
};

const failed = (error, reject) => {
  reject(error);
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http
      .delete(`news_campaigns/${id}`)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/campaign/destroy.js